import { transition, trigger, style, animate } from '@angular/animations';

export const videoChatStatusBubbleAnimation = trigger(
  'videoChatStatusBubbleAnimation',
  [
    transition(
      ':leave', [
        style({ transform: 'scale(1)' }),
        animate('.2s', style({ transform: 'scale(0)' }))
      ]
    )
  ]
);
